// Func = limiting Scope for this file
var lastScrollTop = 0;

if ('NodeList' in window && !NodeList.prototype.forEach) {
    console.info('polyfill for IE11');
    NodeList.prototype.forEach = function (callback, thisArg) {
        thisArg = thisArg || window;
        for (let i = 0; i < this.length; i++) {
            callback.call(thisArg, this[i], i, this);
        }
    };
}

(function(){

    let itemsMenu = document.querySelectorAll('.privary-navigation .privary-navigation__item');
	itemsMenu.forEach((itemMenu)=>{
		if(itemMenu.querySelector('.submenu')){
			itemMenu.addEventListener('mouseenter',()=>{
				itemMenu.classList.add('hover');
				itemMenu.querySelector('.submenu').classList.add('show');
			});
			itemMenu.addEventListener('mouseleave',()=>{
				itemMenu.classList.remove('hover');
				itemMenu.querySelector('.submenu').classList.remove('show');
			})
		}
	})

    window.onload = function() {
	    scrollDownAction(100, 'scroll');
		scrollW();
		window.addEventListener('scroll', function(){
			scrollW();
		})
		if ('scrollRestoration' in history) {
			history.scrollRestoration = 'manual';
		}
	};

    // Remove empty <p> tags created by tinymce
    const paragraph = document.querySelectorAll('p') || [];
	paragraph.forEach( e => (e.innerHTML.trim() === '') && e.parentNode.removeChild(e));

	const inputs = document.querySelectorAll(`
		#email-signup input,
		#email-signup textarea,
		#email-signup select,
		.form-module__field input:not([type="checkbox"]):not([type="radio"]),
		.form-module__field textarea,
		.form-module__field select
	`);

	inputs.forEach(input => {

		const parent = input.parentElement;

		input.addEventListener('focus', () => {
			parent.classList.add('moved');
		});

		input.addEventListener('input', () => {
			parent.classList.add('moved');
		});

		input.addEventListener('blur', () => {
			if (input.value.trim() === '') {
				parent.classList.remove('moved');
			}
		});

		// 👉 si ya viene con valor (ej: autofill)
		if (input.value.trim() !== '') {
			parent.classList.add('moved');
		}

	});

	    // menu 
	if(document.querySelector('.menus-quad__filter')){
		let tabsMenu = document.querySelectorAll('.menus-quad__filter li');
		let allMenus = document.querySelectorAll('.menus-quad__container .menus-quad__menu');
		let lastClickMenu = null;

		tabsMenu.forEach((tab)=>{
			tab.addEventListener('click', ()=>{
				let menuId = tab.dataset.menu;
				if(lastClickMenu){
					lastClickMenu.classList.remove('active');
				}
				tab.classList.add('active');
				allMenus.forEach((menu)=>{
					menu.classList.toggle('hidden', menuId != menu.dataset.menu);
				})
				lastClickMenu = tab;
			})
		})

		tabsMenu[0].click();
	}

		// menu accordion
	if(	document.querySelectorAll('.js-menu--accordion')) {
		let menuAccordion = document.querySelectorAll('.js-menu--accordion');
		menuAccordion.forEach(ele => {
			ele.addEventListener('click' , () => {
				ele.classList.toggle('open');
			})
		});
		
	}

		// accordion

	if(	document.querySelectorAll('.js-accordion-title')) {
		let allAccordionItems = document.getElementsByClassName('js-accordion-title');
        let allALength = allAccordionItems.length;

        for(let i =0; i < allALength; i++){
            allAccordionItems[i].addEventListener('click', function(){
                let currentParent = this.parentElement;
                let currentCopyHeight = currentParent.getElementsByClassName('wrap')[0].clientHeight;
                let currentCopy = currentParent.getElementsByClassName('js-accordion-copy')[0];
                if(currentParent.classList.contains('open')){
                    currentParent.classList.remove('open');
                    currentCopy.style.height = '0';
                } else {
                    currentParent.classList.add('open');
                    currentCopy.style.height = currentCopyHeight + 'px';
                }
            })
        }
	}
			/// menu  mobile ////
	let openMenu = document.getElementById("burgerMenu");
	if( openMenu ){
		openMenu.addEventListener("click", function() {
		document.querySelector(".js-navigation").classList.add("active");
		});
	}

	let closeMenu = document.querySelector(".close-menu");
	if(closeMenu){
		closeMenu.addEventListener("click", function() {
		document.querySelector(".js-navigation").classList.remove("active");
		});
	}

	let mobileNav = document.querySelector(".js-navigation ul:not(.social-media)");
	if(mobileNav != null) {
		mobileNav.addEventListener("click", (e) => {
			let target = e.target.closest("li");
	
			if (!target)
				return;
	
			target.classList.toggle("active");
		});
	}

	document.querySelectorAll(`
	#default.no-image .header__logo img,
	#default-text.no-image .header__logo img,
	#attractions .header__logo img,
	.sitemap .header__logo img,
	#gallery-grid .header__logo img
	`).forEach(logo => {
	logo.src = "assets/svg/logo-green.svg";
	});

	var btnRooms  = document.getElementById('action-ROOMS');
	var btnSuites = document.getElementById('action-SUITES');

	if (btnRooms) {
		btnRooms.addEventListener('click', function(e) {
			e.preventDefault();
			document.dispatchEvent(new CustomEvent('filterRoomsAction', { detail: { type: 'Room' } }));
			var section = document.querySelector('.rooms');
			if (section) section.scrollIntoView({ behavior: 'smooth' });
		});
	}

	if (btnSuites) {
		btnSuites.addEventListener('click', function(e) {
			e.preventDefault();
			document.dispatchEvent(new CustomEvent('filterRoomsAction', { detail: { type: 'Suite' } }));
			var section = document.querySelector('.rooms');
			if (section) section.scrollIntoView({ behavior: 'smooth' });
		});
	}


})();


function scrollW(){
	//check scroll down or up for header styles
	let st = window.pageYOffset || document.documentElement.scrollTop;
	if(st > 100){
		if (st > lastScrollTop){
			// downscroll code
			if(!document.getElementById('header').classList.contains('down')){
				document.getElementById('header').classList.add('down');
				document.getElementById('header').classList.remove('up');
				// document.getElementById('header').classList.add('scroll');
			}
		} else {
			// upscroll code
			if(!document.getElementById('header').classList.contains('up')){
				document.getElementById('header').classList.add('up');
				document.getElementById('header').classList.remove('down');
			}
		}
	} else {
		if(document.getElementById('header').classList.contains('up') || document.getElementById('header').classList.contains('down')){
			document.getElementById('header').classList.remove('up');
			document.getElementById('header').classList.remove('down');
				// document.getElementById('header').classList.remove('scroll');
		}
	}
	lastScrollTop = st <= 0 ? 0 : st; // For Mobile or negative scrolling
}